
namespace RioERP.Wallet {
    export class CreditWalletColumns {
        static columnsKey = 'Wallet.CreditWallet';
    }
}